import React, { useEffect, useRef, useState } from 'react';
// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './paral.css'
import './paral1.css'
import './scroll.css'
import '../BybMainPage/BybToolkit/BybToolkit.css'
import "../BybMainPage/OverlayVideoSection.css";
import "../BybMainPage/BybChecklist/BybChecklist.css";
// import VideoModal from "../../src/VideoModal";
// import PlayButton from "../../src/PlayButton";
// import CustomerJourney from '../../src/assets/images/Customer-Journey.svg'

function Header() {

  const panelsRef = useRef([]);
 const [modal, setModal] = useState(false);
  const [videoLoading, setVideoLoading] = useState(true);

  // const openModal = () => {
  //   setModal(!modal);
  // };

  // const spinner = () => {
  //   setVideoLoading(!videoLoading);
  // };

  const [isVisible, setIsVisible] = useState(true);

  const textRef = useRef(null);

  // Intersection Observer for fade-in text
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting); // Set visibility based on intersection
      },
      {
        threshold: 0.5, // Trigger when 50% of the element is visible
      }
    );

    const textElement = textRef.current;
    if (textElement) observer.observe(textElement);

    return () => {
      if (textElement) observer.unobserve(textElement);
    };
  }, []);

  // useEffect(() => {
  //   gsap.registerPlugin(ScrollTrigger);

  //   let panels = panelsRef.current;
  //   let tops = panels.map(panel => ScrollTrigger.create({ trigger: panel, start: "top top" }));

  //   panels.forEach((panel) => {
  //     ScrollTrigger.create({
  //       trigger: panel,
  //       start: () => panel.offsetHeight < window.innerHeight ? "top top" : "bottom bottom",
  //       pin: true,
  //       pinSpacing: false
  //     });
  //   });

  //   ScrollTrigger.create({
  //     snap: {
  //       snapTo: (progress, self) => {
  //         let panelStarts = tops.map(st => st.start());
  //         let snapScroll = gsap.utils.snap(panelStarts, self.scroll());
  //         return gsap.utils.normalize(0, ScrollTrigger.maxScroll(window), snapScroll);
  //       },
  //       duration: 0.5
  //     }
  //   });

  //   return () => {
  //     ScrollTrigger.getAll().forEach(trigger => trigger.kill());
  //   };
  // }, []);

  // const [isOpen, setOpen] = useState(false);

  // function handleChange() {
  //   setOpen(!isOpen);
  // }

  return (
    <>
      <div className="description panel new_byb byb-toolkit" ref={el => panelsRef.current[0] = el} id="header_text">
        <div className="legacy-content py-0">

        </div>
      </div>
      {/* </div> */}
      <section className="brand_journey " style={{backgroundColor:"rgb(7, 26, 40)"}} >
            <div className="container">

              <p className='journey_p byb-about-entity-copy'>Brew Your Brand (BYB) is a brand-building platform for founders, entrepreneurs, marketers, and MSME teams that want clearer positioning and stronger customer experience. It offers brand self-audit tools, a quick brand assessment, strategy guides, eMagazine insights, learning resources, and a creative community to help businesses build more consistent, memorable brands.</p>
              <p className='journey_p byb-journey-intro'>Professionals, Entrepreneurs and Enthusiasts from across the branding spectrum come together, to share insights, spark fresh ideas, and refine the craft of brewing brands that will stay relevant, decades later.</p>
              <div className="row">

                <div className="col-lg-5 d-block d-lg-flex align-items-center">
                <p>
                Whether you’re just <span className='text-white'>beginning your branding journey or refining a mature strategy,</span> this is where you’ll find the tools, the community, and the inspiration to make it all happen
                 </p>
                </div>
                <div className="col-lg-7 enthu">
                    <img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/Customer-Journey.svg" alt="Customer journey community visual" />
                </div>
              </div>
            </div>
               

                <div className="row">

                </div>
      </section>
    </>
  );
}

export default Header;
